<template>
  <div class="user-menu">
    <v-menu
      offset-y
      :close-on-content-click="false"
      light
      transition="slide-y-transition"
    >
      <template #activator="{on}">
        <StUserAvatar
          size="36"
          color="grey lighten-4"
          class="user-menu__image"
          :user="user"
          :user-image-path="userImagePath"
          v-on="on"
        />
      </template>

      <StUserMenuList
        :user="user"
        :items="items"
        :logout-label="logoutLabel"
        :terms-of-use="termsOfUse"
        :privacy-policy="privacyPolicy"
        :greeting="greeting"
        @menu-list-item-clicked="$emit('menu-list-item-clicked', $event)"
        @logout-item-clicked="$emit('logout-item-clicked', $event)"
        @terms-clicked="$emit('terms-clicked', $event)"
        @privacy-policy-clicked="$emit('privacy-policy-clicked', $event)"
      />
    </v-menu>
  </div>
</template>

<script>
import Vue from 'vue';
import { VMenu } from 'vuetify';
import StUserAvatar from '@stilingue/st-user-avatar/StUserAvatar';
import '@stilingue/st-styles/main.scss';
import StUserMenuList from './StUserMenuList';

Vue.component('v-menu', VMenu);

export default {
  name: 'StUserMenu',
  components: {
    StUserAvatar,
    StUserMenuList,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    greeting: {
      type: String,
      required: true,
    },
    userImagePath: {
      type: String,
      default: 'img',
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    logoutLabel: {
      type: String,
      default: 'Logout',
    },
    termsOfUse: {
      type: String,
      default: 'Termos de uso',
    },
    privacyPolicy: {
      type: String,
      default: 'Política de privacidade',
    },
  },
};
</script>

<style scoped>
  .user-menu {
    cursor: pointer;
  }
</style>
